import React, { useMemo } from 'react';
import { Wrapper, Inner, Content, Title, Text } from './styled';
import useScreenSize from '../../../hooks/useScreenSize';
import {
  LandingBrandBanner,
  LandingBrandBannerVisibleOnEnum as V
} from '../../../graphql/types';
import { useClient } from '../../../hooks/useClient';

interface Props {
  banners?: LandingBrandBanner[] | null;
}

const pickBanner = (banners: LandingBrandBanner[], slot: V) => {
  if (!banners?.length) return undefined;
  return banners.find(
    b => Array.isArray(b.visibleOn) && b.visibleOn.includes(slot)
  );
};

export const AdriverBannerBlock: React.FC<Props> = ({ banners = [] }) => {
  const { isSmallOrLargeDesktop, isTablet } = useScreenSize();
  const isClient = useClient();

  let slot: V;
  if (isSmallOrLargeDesktop) {
    slot = V.Desktop;
  } else if (isTablet) {
    slot = V.Tablet;
  } else {
    slot = V.Mobile;
  }

  const banner = useMemo(
    () => pickBanner(banners ?? [], slot),
    [banners, slot]
  );

  if (!banner?.coverUrl) return null;

  const linkProps = banner.url
    ? {
        as: 'a',
        href: banner.url,
        target: '_blank',
        rel: 'noopener noreferrer'
      }
    : { as: 'div' };

  return (
    <Wrapper>
      {isClient && (
        <Inner $bg={banner.coverUrl} {...linkProps}>
          <Content $color={banner.textColor || '#fff'}>
            {banner.title && <Title>{banner.title}</Title>}
            {banner.text && <Text>{banner.text}</Text>}
          </Content>
        </Inner>
      )}
    </Wrapper>
  );
};
